export default __webpack_public_path__ + "static/Yunita Tirtasari Soenaryo-1fe509141495d23b46336d80156ef388.webp";